export default {
  LOAD_SSO_CONFIG (state, payload) {
    state.ssoConfig = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/login/vuex/mutations.js